/**
 * Minimal TipTap doc → plain text extractor.
 *
 * Walks `node.content` recursively, accumulates `node.text` from text nodes,
 * joins with spaces. Returns `''` for invalid or empty input.
 *
 * v1 minimal extractor — kept local to the briefs table row because no
 * shared TipTap-to-text utility exists in the codebase yet (`grep` for
 * `extractText`/`toPlainText`/`tiptap` only found the editor wrappers used
 * by `entities/project-comment`). Promote to `@/shared` if a richer
 * renderer/extractor is needed elsewhere.
 */
export const extractTipTapText = (doc: Record<string, unknown> | undefined): string => {
  if (!doc || typeof doc !== 'object') return '';
  const parts: string[] = [];
  const walk = (node: unknown) => {
    if (!node || typeof node !== 'object') return;
    const n = node as { text?: unknown; content?: unknown };
    if (typeof n.text === 'string') parts.push(n.text);
    if (Array.isArray(n.content)) n.content.forEach(walk);
  };
  walk(doc);
  return parts.join(' ').trim();
};
